import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getCompany, getPopups } from '../selectors';

import Header from './Header';
import MainSection from './MainSection';

import ErrorBoundary from '../components/ErrorBoundary';
import Overlay from '../components/Overlay';
import CompanyCollectionsPage from '../components/CompanyCollectionsPage';

class CompanyApp extends Component {

  render() {
    const { popups, company, identity } = this.props;

    return (
      <ErrorBoundary>
        <Header></Header>
        <MainSection popups={popups}>
          <CompanyCollectionsPage company={company} identity={identity} />
        </MainSection>
        <Overlay popups={popups} />
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    identity: state.identity,
    company: getCompany(state, { company_id: ownProps.params?.id }),
    popups: getPopups(state),
  };
};

export default connect(mapStateToProps)(CompanyApp);
